module.exports = __webpack_public_path__ + "assets/img/arrow_rleft_alt.d032f1b8.svg";